import { useRef } from 'react';
import { isFreeSearchField } from './FieldSelectorSection';

/**
 * Tracks whether the user just switched to the free-search field so the value input can be
 * auto-focused once, right after the switch, without stealing focus on subsequent re-renders.
 */
export const useFreeSearchAutoFocus = (fieldName?: string | null) => {
  const freeTextUserSelectedRef = useRef(false);
  const shouldAutoFocusFreeText = freeTextUserSelectedRef.current && isFreeSearchField(fieldName);
  if (shouldAutoFocusFreeText) freeTextUserSelectedRef.current = false;

  const markFreeSearchSelected = () => {
    freeTextUserSelectedRef.current = true;
  };

  return { markFreeSearchSelected, shouldAutoFocusFreeText };
};
